<template>
	<div class="dashboard-editor-container">
		<div class=" clearfix" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'DashboardEditor',
	data() {
		return {};
	},
	computed: {
		...mapGetters(['name', 'avatar', 'roles'])
	}
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
	background-color: #fff !important;
	min-height: 100vh;
	padding: 50px 60px 0px;
	.pan-info-roles {
		font-size: 12px;
		font-weight: 700;
		color: #333;
		display: block;
	}
	.info-container {
		position: relative;
		margin-left: 190px;
		height: 150px;
		line-height: 200px;
		.display_name {
			font-size: 48px;
			line-height: 48px;
			color: #212121;
			position: absolute;
			top: 25px;
		}
	}
}
</style>
